import React from 'react';
import HelperClassesContainer from '../../Componant/UiKits/HelperClass';

const HelperClasses = () => {
  return (
    <div className='page-body'>
      <HelperClassesContainer />
    </div>
  );
};

export default HelperClasses;
